<template>
  <RevDrawer
    :close-button-label="i18n(translations.closeButtonLabel)"
    :name="name"
    :title="i18n(translations.drawerTitle)"
  >
    <template #body>
      <RevIllustration
        :alt="i18n(translations.bouyguesIcon)"
        class="mb-8"
        :height="24"
        src="/img/bouygues/bouyguesLogoSquare.svg"
        :width="24"
      />
      <div class="space-y-32">
        <h1 class="heading-1">{{ i18n(translations.title) }}</h1>

        <div>
          <h2 class="heading-2">
            {{ i18n(translations.numberBouyguesTitle) }}
          </h2>
          <div class="body-1">
            {{ i18n(translations.bouyguesPhoneTransfer) }}
          </div>
        </div>

        <div>
          <h2 class="heading-2">{{ i18n(translations.assistanceTitle) }}</h2>
          <div class="body-1">
            {{ i18n(translations.bouyguesPortalAccess) }}
          </div>
        </div>

        <div>
          <h2 class="heading-2">
            {{ i18n(translations.changeYourMindTitle) }}
          </h2>
          <div class="body-1">{{ i18n(translations.returnPolicy) }}</div>
        </div>

        <div>
          <h2 class="heading-2">
            {{ i18n(translations.customerSpaceTitle) }}
          </h2>
          <div class="body-1">{{ i18n(translations.customerSpace) }}</div>
        </div>
      </div>
    </template>
  </RevDrawer>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDrawer } from '@ds/components/Drawer'
import { RevIllustration } from '@ds/components/Illustration'

import translations from './BouyguesAssistanceDrawer.translations'

const i18n = useI18n()

defineProps<{ name: string }>()
</script>
